import { render, staticRenderFns } from "./SubaccountsOwner.vue?vue&type=template&id=c1c253c4&"
import script from "./SubaccountsOwner.vue?vue&type=script&lang=js&"
export * from "./SubaccountsOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports